import { render, staticRenderFns } from "./Role.vue?vue&type=template&id=5bbd8224&"
import script from "./Role.vue?vue&type=script&lang=ts&"
export * from "./Role.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports